import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Typography, message } from 'antd';

import AuctionForm from './components/AuctionForm/AuctionForm';

import { redirectToLoginPage } from 'utils';
import { resetAuctionFormState, setAuctionFormState } from 'features/auctionFormSlice';

import useAppSelector from 'hooks/useAppSelector';
import useNavigateToPrev from 'hooks/useNavigateToPrev';

import styles from './CreateAuction.module.css';

const { Title } = Typography;

function CreateAuction() {
  const [createdAuctionId, setCreatedAuctionId] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigateToPrev = useNavigateToPrev();
  const [isCreated, setIsCreated] = useState(false);

  const { authenticated, loginUser } = useAppSelector((state) => state.user);
  const isSeller = loginUser?.role === 'seller';

  useEffect(() => {
    if (!authenticated) {
      message.info('로그인이 필요한 페이지입니다.');
      redirectToLoginPage(navigate);
    } else if (!isSeller) {
      message.error('경매 생성 권한이 없습니다.');
      navigateToPrev();
    } else {
      // 페이지 최초 접근 시 초기화
      window.scrollTo(0, 0);
      dispatch(resetAuctionFormState());
      const { default_shipping_methods, default_payment, default_return_policy } = loginUser;
      dispatch(
        setAuctionFormState({
          shippingMethods: default_shipping_methods,
          payment: default_payment,
          returnPolicy: default_return_policy,
          invitationCodeRequired: loginUser.marketplace_id === process.env.REACT_APP_PUBLIC_MARKETPLACE_ID,
        })
      );
    }
  }, [authenticated, dispatch, isSeller, loginUser, navigate]);

  useEffect(() => {
    if (isCreated) {
      dispatch(resetAuctionFormState());
      navigate(`/auctions/${createdAuctionId}`);
    }
  }, [dispatch, createdAuctionId, isCreated, navigate]);

  const closeAuctionForm = (createdAuctionId: string) => {
    setIsCreated(true);
    setCreatedAuctionId(createdAuctionId);
  };

  return isSeller ? (
    <div className={styles.container}>
      <Title className={styles.title} level={1}>
        상품등록
      </Title>
      <AuctionForm closeAuctionForm={closeAuctionForm} />
    </div>
  ) : null;
}

export default CreateAuction;
